var $ = global.jQuery = global.$;
var mapConfig = require('../config').maps;
var widgets = require('../lib/widgets');

var _pluck = require('lodash/collection/pluck');
var _uniq = require('lodash/array/uniq');
var _filter = require('lodash/collection/filter');
var _sortBy = require('lodash/collection/sortBy');
var _find = require('lodash/collection/find');
var _map = require('lodash/collection/map');

var _Base = require('./_Base');
/**
 * Locations widget.
 * @class
 * @extends _Base
 */
var Locations = _Base.extend(
  /** @lends Locations.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;
    this.locationsUrl = this.$el.data('locations');
    this.$el.on('Map:loaded', function() {
      self.getItems();
    });

  },
  /**
   * Fires once when all widgets are loaded
   * @private
   */
  onWidgetsReady: function() {
    var self = this;
    this.map = widgets.getDescendants(this.$el, '_Map')[0];
    this.form = widgets.getDescendants(this.$el, 'Form')[0];

    //Reset field values to 0 before we do anything as browser back button sets them to null
    this.form.setFieldValues({
      Country: 0,
      Location: 0,
      Region: 0
    });

    this.fields = widgets.getDescendants(this.$el, 'Field');

    this.regionField = _find(this.fields, {
      'name': 'Region'
    });
    this.countryField = _find(this.fields, {
      'name': 'Country'
    });
    this.locationField = _find(this.fields, {
      'name': 'Location'
    });

    this.form.$el.on('Field:updated', function(event, name, value) {
      var items = self.getFilteredItems(name, value);
      self.updateLocations(items);
      self.updateFields(name, items);
    });

  },
  /**
   * Update the region, country and locations dropdowns
   * @param {string} triggerField The name of the field that triggered the filed update
   * @param {Object[]} items - The items returned from the getItems call
   * @param {string} items[].Name - The name of the location
   * @param {number} items[].Latitude - The latitude of the location
   * @param {number} items[].Longitude - The longitude of the location
   * @param {string} items[].Region - The region
   * @param {string} items[].Country - The country
   * @param {string} items[].Location - The location name
   * @param {string} items[].Url - The url to the locations detail page
   */
  updateFields: function(triggerField, items) {
    var self = this;
    var filterValues = this.getFilterLocations(items);

    this.regionField.externalSuppressEvents = true;
    this.countryField.externalSuppressEvents = true;
    this.locationField.externalSuppressEvents = true;

    switch (triggerField) {
      case 'Region':
        this.countryField.updateSelectOptions(filterValues.countries, false, true);
        this.countryField.setSelectIndex(0);
        if (filterValues.countries.length === 1) {
          this.countryField.setSelectIndex(1);
        }
        this.locationField.updateSelectOptions(filterValues.locations, false, true);
        this.locationField.setSelectIndex(0);
        if (filterValues.locations.length === 1) {
          this.locationField.setSelectIndex(1);
        }
        break;
      case 'Country':
        this.locationField.updateSelectOptions(filterValues.locations, false, true);
        this.locationField.setSelectIndex(0);
        if (filterValues.locations.length === 1) {
          this.locationField.setSelectIndex(1);
        }
        break;
      case 'Location':
        break;
      default:
        this.regionField.updateSelectOptions(filterValues.regions, false, true);
        this.countryField.updateSelectOptions(filterValues.countries, false, true);
        this.locationField.updateSelectOptions(filterValues.locations, false, true);
    }

    this.regionField.externalSuppressEvents = false;
    this.countryField.externalSuppressEvents = false;
    this.locationField.externalSuppressEvents = false;
  },
  /**
   * Get the filtered items
   * @param {string} triggerField The name of the field that triggered the filed update
   * @param {string} value The value of the field that triggered the update
   * @returns {array} array of filtered locations
   */
  getFilteredItems: function(triggerField, value) {
    var criteria = {};

    if (triggerField) {

      if (value !== '0') criteria[triggerField] = value;

      switch (triggerField) {
        case 'Country':
          if (this.regionField.getValue() !== '0') criteria.Region = this.regionField.getValue();
          break;
        case 'Location':
          if (this.regionField.getValue() !== '0') criteria.Region = this.regionField.getValue();
          if (this.countryField.getValue() !== '0') criteria.Country = this.countryField.getValue();
          break;
      }
    }

    return _filter(this.locations, criteria);
  },
  /**
   * Add the locations to the map
   * @param {Object[]} locations - The items returned from the getItems call
   * @param {string} locations[].Name - The name of the location
   * @param {number} locations[].Latitude - The latitude of the location
   * @param {number} locations[].Longitude - The longitude of the location
   * @param {string} locations[].Url - The url to the locations detail page
   */
  addLocations: function(locations) {
    this.locations = locations;
    this.updateLocations(locations);
  },
  /**
   * Update the locations
   * @param {Object[]} locations - The items returned from the getItems call
   * @param {string} locations[].Name - The name of the location
   * @param {number} locations[].Latitude - The latitude of the location
   * @param {number} locations[].Longitude - The longitude of the location
   * @param {string} locations[].Url - The url to the locations detail page
   */
  updateLocations: function(locations) {
    var self = this;
    var markers = [];
    this.map.cluster.clearMarkers();
    $.each(locations, function() {
      var marker = self.map.createMarker(this.Latitude, this.Longitude, {
        title: this.Name
      });
      marker.url = this.Url;

      self.map.google.maps.event.addListener(marker, 'click', function() {
        window.location.assign(this.url);
      });

      markers.push(marker);
    });
    this.map.addMarkers(markers, true);
    this.map.cluster.fitMapToMarkers();
  },
  /**
   * Get the locations from the locationsUrl
   */
  getItems: function() {
    var self = this;
    var req = $.ajax({
        type: 'GET',
        contentType: 'application/json',
        url: self.locationsUrl,
        data: {
          CurrentPageId: $('[name=CurrentPageId]').val()
        }
      })
      .done(function(response) {
        self.addLocations(response.Value);
        setTimeout(function() {
          self.updateFields('', self.getFilteredItems());
        }, 100);
      })
      .fail(function() {

      })
      .always(function() {

      });

    return req;
  },
  /**
   * Get the filter criteria values based on the locations
   * @param {Object[]} items - The items returned from the getItems call
   * @param {string} items[].Name - The name of the location
   * @param {number} items[].Latitude - The latitude of the location
   * @param {number} items[].Longitude - The longitude of the location
   * @param {string} items[].Region - The region
   * @param {string} items[].Country - The country
   * @param {string} items[].Location - The location name
   * @param {string} items[].Url - The url to the locations detail page
   * @returns {FilterValues} The available filter values
   */
  getFilterLocations: function(items) {
    var filterValues = {
      regions: _sortBy(_uniq(_pluck(items, 'Region'))),
      countries: _sortBy(_uniq(_pluck(items, 'Country'))),
      locations: _sortBy(_uniq(_pluck(items, 'Location')))
    };

    function createOptionValue(item) {
      return {
        'Text': item
      };
    }

    filterValues.regions = _map(filterValues.regions, createOptionValue);
    filterValues.countries = _map(filterValues.countries, createOptionValue);
    filterValues.locations = _map(filterValues.locations, createOptionValue);

    return filterValues;
  }
});

module.exports = Locations;

/**
 * @typedef FilterValues
 * @memberof Locations
 * @type Object
 * @property {array} regions The available regions
 * @property {array} countries The available countries
 * @property {array} locations The available locations
 */



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/Locations.js
 ** module id = 160
 ** module chunks = 0 1
 **/